<template>
    <app-layout :title="'Preview survey: ' + surveyModel.name" :survey-layout="true">
        <survey :preview="true" :surveyModel="surveyModel" :survey-responses="{}"/>
    </app-layout>
</template>

<script>
import Survey from "@/Components/Survey";
import AppLayout from "@/Layouts/AppLayout";
export default {
    name: "Show",
    components: {AppLayout, Survey},
    props: {
        surveyModel: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
